<h2 class="mt-5">{{cardConfiguration.title}}</h2>



<!-- Booleans in VM are being considered string @ runtime, boolean validationsn need to be changed once they are the proper type @ runtime-->
<fieldset [disabled]="isWorkflowOnSubscriber">
  <div class="row">
    <div class="col-sm-5">
      <div class="form-group">
          <label for="HasDebts">
              <span class="mandatory">*</span>{{'CardTimeCount.HasDebts' | translate}}
              <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.CardTimeCount.HasDebts' | translate}}"></span>
          </label>
        
        <div class="btn-group btn-group-toggle" >
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.hasDebts" [radioLabel]="hasDebts">
            <input type="radio" [(ngModel)]="cardData.hasDebts" name="hasDebts" #hasDebts="ngModel" [value]="domain.value" required
                   [clearRelated]="{model : this.cardData , propsToReset : ['valuePayed']} ">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>


      </div>
    </div>
    <div class="col-sm-5">
      <div class="form-group">
        <label [class.disabled]="!cardData.hasDebts || cardData.hasDebts?.toString() !='true'"><span class="mandatory" *ngIf="cardData.hasDebts?.toString()=='true'">*</span>{{'CardTimeCount.ValuePayed' | translate}}</label>
        <div class="position-relative">
          <input class="form-control input-left" type="text" currency
                 placeholder="{{'Placeholders.Generic.Currency' | translate}}"
                 [(ngModel)]="cardData.valuePayed" name="address" #valuePayed="ngModel" [required]="cardData.hasDebts?.toString()=='true'"
               [disabled]="!cardData.hasDebts || cardData.hasDebts?.toString() !='true'">
               <span class="input-icon-span-left">€</span>
        <validation-message [control]="valuePayed"></validation-message>
        </div>
      </div>
    </div>
    <div><span>Caso existam dívidas em curso deve ser suspenso o pagamento das mesmas até que seja dada decisão sobre o pedido de aposentação</span></div>
  </div>
</fieldset>
<!--<pre>{{cardData | json}}</pre>-->
